<div
  class="gcc-timepicker dropdown"
  bsDropdown
  [isOpen]="isDropdownOpen"
  [isDisabled]="isDisabled"
  (click)="onDropdownToggle($event)"
>
  <div class="form-control dropdown clickable d-flex align-items-center">
    <div class="flex-grow-1">
      <input
        type="text"
        class="hours"
        maxlength="2"
        placeholder="00"
        [value]="hours"
        [disabled]="isDisabled"
        (focus)="onHoursFocus()"
        (input)="onHoursChange($event)"
        #hoursInput
      />
      <span class="separator">:</span>
      <input
        type="text"
        class="minutes"
        maxlength="2"
        placeholder="00"
        [value]="minutes"
        [disabled]="isDisabled"
        (focus)="onMinutesFocus()"
        (blur)="onMinutesBlur()"
        (input)="onMinutesChange($event)"
        #minutesInput
      />
      @if (showMeridian) {
        <input
          type="text"
          class="meridian"
          maxlength="2"
          placeholder="AM"
          readonly
          [disabled]="isDisabled"
          [value]="meridian"
          (focus)="onMeridianFocus()"
          #meridianInput
        />
      }
    </div>
    <i class="icon icon-clock text-gray"></i>
  </div>
  <div class="dropdown-menu note" role="menu" *dropdownMenu>
    <div class="row px-1" [ngClass]="{ 'px-1': viewMode !== 'a' }">
      @switch (viewMode) {
        @case (h) {
          @for (h of hourOptions; track h) {
            <div (click)="onHoursSelect(h)" class="dropdown-item text-center clickable col-4" role="menuitem">
              {{ h }}
            </div>
          }
        }
        @case (m) {
          @for (m of minuteOptions; track m) {
            <div (click)="onMinutesSelect(m)" class="dropdown-item text-center clickable col-6" role="menuitem">
              {{ m }}
            </div>
          }
        }
        @case (a) {
          @for (m of meridianOptions; track m) {
            <div (click)="onMeridianSelect(m)" class="dropdown-item px-3 clickable" role="menuitem">
              {{ m }}
            </div>
          }
        }
      }
    </div>
  </div>
</div>
